var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { Button } from "../../../../../../../../Components/UI";
import { Translate } from "../../../../../../../../../I18N";
import { ArrowRightIcon } from '@heroicons/react/20/solid';
import { useCreateExtractorContext } from "../../CreateExtractorContext";

const Footer = () => {
  const { targetTemplateId, setStep, setShowModal } = useCreateExtractorContext();
  return (/*#__PURE__*/
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx(Button, { styling: "light", onClick: () => setShowModal(false), className: "grow" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Cancel")
    ), /*#__PURE__*/
    _jsx(Button, {
      className: "grow bg-indigo-800 disabled:opacity-50",
      onClick: () => setStep(2),
      disabled: !targetTemplateId }, void 0, /*#__PURE__*/

    _jsx("span", { className: "flex items-center justify-center gap-2 flex-nowrap" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Next"), /*#__PURE__*/
    _jsx(ArrowRightIcon, { className: "w-5" })
    )
    )
    ));

};

export { Footer };